import { useEffect, useState } from "react"
import ListLayout from "../../components/layout/main/ListLayout"
import { useAclContext } from "../../core/contexts/acl"
import { useQueryContext } from "../../core/contexts/query"
import { useGetRewardConfig, useSetRewardConfig } from "../../core/services/react-query/reward"
import { Background, CFlex, CMargin, DText, Flex } from "../../styles/CommonStyles"
import { UserDetailSettingBox } from "../../styles/main/user"
import Text from "../../core/utils/Text"
import CheckBox from "../../components/common/input/CheckBox"
import Input from "../../components/common/input/Input"
import ActionButton from "../../components/common/buttons/ActionButton"
import NoAccess from "../../components/layout/main/NoAccess"
import { ScaleLoader } from "react-spinners"
import CoinSelect from "../../components/common/input/CoinSelect"
import { useAvailableCoins } from "../../core/services/react-query/setting"

export default function Reward() {
    const { setToast } = useQueryContext()
    const { permissions } = useAclContext()
    const hasWriteAccess = true

    const initialState = {
        reward: false,
        invitedReward: {
            isActive: false,
            currency: 'irt',
            amount: 0,
        },
        invitedOnDepositReward: {
            isActive: false,
            sharePercentFromWage: 0,
        },
        invitedOnOtcTradeReward: {
            isActive: false,
            sharePercentFromWage: 0,
        },
        invitedOnP2pTradeReward: {
            isActive: false,
            sharePercentFromWage: 0,
        },
        invitedOnSwapReward: {
            isActive: false,
            sharePercentFromWage: 0,
        },
        invitedOnCardReward: {
            isActive: false,
            sharePercentFromWage: 0
        },
        invitedOnTransferReward: {
            isActive: false,
            sharePercentFromWage: 0
        }
    }

    const [rewardConfig, setRewardConfig] = useState(initialState)

    const { mutate, isLoading, isSuccess } = useSetRewardConfig()
    const { data, loading: loadingConfig } = useGetRewardConfig()
    const { data: availableCoins } = useAvailableCoins()

    const coins = availableCoins
        ? [...availableCoins, { id: 'irt', fa: 'تومان', name: 'Tooman' }]
        : []

    const onValueChange = (value, path) => {
        const updated = { ...rewardConfig }
        const keys = path.split('.')
        let obj = updated
        for (let i = 0; i < keys.length - 1; i++) obj = obj[keys[i]]
        obj[keys.at(-1)] = value
        setRewardConfig(updated)
    }

    const onSubmit = () => {
        mutate(rewardConfig)
    }

    useEffect(() => {
        if (isSuccess) {
            setToast({ show: true, message: 'reward-config-updated' })
        }
    }, [isSuccess])

    useEffect(() => {
        if (data) {
            setRewardConfig(prev => ({
                ...prev,
                ...data,
                invitedReward: {
                    ...prev.invitedReward,
                    ...data.invitedReward,
                },
                invitedOnDepositReward: {
                    ...prev.invitedOnDepositReward,
                    ...data.invitedOnDepositReward,
                },
                invitedOnOtcTradeReward: {
                    ...prev.invitedOnOtcTradeReward,
                    ...data.invitedOnOtcTradeReward,
                },
                invitedOnP2pTradeReward: {
                    ...prev.invitedOnP2pTradeReward,
                    ...data.invitedOnP2pTradeReward,
                },
                invitedOnSwapReward: {
                    ...prev.invitedOnSwapReward,
                    ...data.invitedOnSwapReward,
                },
            }))
        }
    }, [data])

    return (
        <CFlex fw className='pt-16'>
            <CMargin margin={'10px'} />
            {loadingConfig && (
                <div className="w-screen h-screen absolute top-0 z-20 backdrop-blur-sm">
                    <div className="flex w-full h-full justify-center items-center">
                        <ScaleLoader color="#ffc800" />
                    </div>
                </div>
            )}

            {hasWriteAccess ? (
                <UserDetailSettingBox>
                    <Background bg='mainBg' className="p-4">
                        <Flex>
                            <CheckBox
                                active={rewardConfig.reward}
                                onClick={() => onValueChange(!rewardConfig.reward, 'reward')}
                            />
                            <DText main><Text tid='enable-reward' /></DText>
                        </Flex>

                        <CMargin margin="10px" />

                        <Flex>
                            <CheckBox
                                active={rewardConfig.invitedReward.isActive}
                                onClick={() =>
                                    onValueChange(
                                        !rewardConfig.invitedReward.isActive,
                                        'invitedReward.isActive'
                                    )
                                }
                            />
                            <SectionTitle title='Invited Reward' />
                        </Flex>

                        <CoinSelect
                            value={coins.find(c => c.id === rewardConfig.invitedReward.currency)}
                            onChange={(coin) => {
                                if (coin?.id) {
                                    onValueChange(coin.id, 'invitedReward.currency')
                                }
                            }}
                            bg={'mainBg'}
                            width={'100%'}
                            hasIrt
                        />

                        <Input
                            label='amount'
                            value={rewardConfig.invitedReward.amount}
                            onInputChange={(v) =>
                                onValueChange(+v, 'invitedReward.amount')
                            }
                        />

                        <CMargin margin="10px" />

                        <Flex>
                            <CheckBox
                                active={rewardConfig.invitedOnDepositReward.isActive}
                                onClick={() =>
                                    onValueChange(
                                        !rewardConfig.invitedOnDepositReward.isActive,
                                        'invitedOnDepositReward.isActive'
                                    )
                                }
                            />
                            <SectionTitle title='On Deposit Reward' />
                        </Flex>

                        <Input
                            label='share-percent-from-wage'
                            value={rewardConfig.invitedOnDepositReward.sharePercentFromWage}
                            onInputChange={(v) =>
                                onValueChange(
                                    +v,
                                    'invitedOnDepositReward.sharePercentFromWage'
                                )
                            }
                        />

                        <CMargin margin="10px" />

                        <Flex>
                            <CheckBox
                                active={rewardConfig.invitedOnOtcTradeReward.isActive}
                                onClick={() =>
                                    onValueChange(
                                        !rewardConfig.invitedOnOtcTradeReward.isActive,
                                        'invitedOnOtcTradeReward.isActive'
                                    )
                                }
                            />
                            <SectionTitle title='On OTC Trade Reward' />
                        </Flex>

                        <Input
                            label='share-percent-from-wage'
                            value={rewardConfig.invitedOnOtcTradeReward.sharePercentFromWage}
                            onInputChange={(v) =>
                                onValueChange(
                                    +v,
                                    'invitedOnOtcTradeReward.sharePercentFromWage'
                                )
                            }
                        />

                        <CMargin margin="10px" />

                        <Flex>
                            <CheckBox
                                active={rewardConfig.invitedOnP2pTradeReward.isActive}
                                onClick={() =>
                                    onValueChange(
                                        !rewardConfig.invitedOnP2pTradeReward.isActive,
                                        'invitedOnP2pTradeReward.isActive'
                                    )
                                }
                            />
                            <SectionTitle title='On P2P Trade Reward' />
                        </Flex>

                        <Input
                            label='share-percent-from-wage'
                            value={rewardConfig.invitedOnP2pTradeReward.sharePercentFromWage}
                            onInputChange={(v) =>
                                onValueChange(
                                    +v,
                                    'invitedOnP2pTradeReward.sharePercentFromWage'
                                )
                            }
                        />

                        <CMargin margin='20px' />
                        <Flex>
                            <CheckBox
                                active={rewardConfig.invitedOnSwapReward.isActive}
                                onClick={() =>
                                    onValueChange(
                                        !rewardConfig.invitedOnSwapReward.isActive,
                                        'invitedOnSwapReward.isActive'
                                    )
                                }
                            />
                            <SectionTitle title='On Swap Reward' />
                        </Flex>

                        <Input
                            label='share-percent-from-wage'
                            value={rewardConfig.invitedOnSwapReward.sharePercentFromWage}
                            onInputChange={(v) =>
                                onValueChange(
                                    +v,
                                    'invitedOnSwapReward.sharePercentFromWage'
                                )
                            }
                        />
                        <CMargin margin='20px' />
                        <Flex>
                            <CheckBox
                                active={rewardConfig.invitedOnCardReward.isActive}
                                onClick={() =>
                                    onValueChange(
                                        !rewardConfig.invitedOnCardReward.isActive,
                                        'invitedOnCardReward.isActive'
                                    )
                                }
                            />
                            <SectionTitle title='On Card Reward' />
                        </Flex>

                        <Input
                            label='share-percent-from-wage'
                            value={rewardConfig.invitedOnCardReward.sharePercentFromWage}
                            onInputChange={(v) =>
                                onValueChange(
                                    +v,
                                    'invitedOnCardReward.sharePercentFromWage'
                                )
                            }
                        />
                        <CMargin margin='20px' />
                        <Flex>
                            <CheckBox
                                active={rewardConfig.invitedOnTransferReward.isActive}
                                onClick={() =>
                                    onValueChange(
                                        !rewardConfig.invitedOnTransferReward.isActive,
                                        'invitedOnTransferReward.isActive'
                                    )
                                }
                            />
                            <SectionTitle title='On Internal Transfer' />
                        </Flex>

                        <Input
                            label='share-percent-from-wage'
                            value={rewardConfig.invitedOnTransferReward.sharePercentFromWage}
                            onInputChange={(v) =>
                                onValueChange(
                                    +v,
                                    'invitedOnTransferReward.sharePercentFromWage'
                                )
                            }
                        />

                        <CMargin margin='20px' />
                        <ActionButton active loading={isLoading} onClick={onSubmit}>
                            <Text tid='save-reward-config' />
                        </ActionButton>
                    </Background>
                </UserDetailSettingBox>
            ) : (
                <>
                    <NoAccess width='300px' height='300px' />
                    <DText main><Text tid='no-access' /></DText>
                </>
            )}
        </CFlex>
    )
}

const SectionTitle = ({ title }) => (
    <>
        <CMargin margin='16px' />
        <DText main style={{ fontWeight: 600 }}>
            <Text tid={title} />
        </DText>
        <CMargin margin='8px' />
    </>
)
